export default {
	name: 'movebooks',
	data() {
		return {
			getData: {},
			areaID: this.$store.state.user.areaID,
			Shop: this.$store.state.shop.filter(x => x.areaID == this.$store.state.user.areaID),
			ShopID: this.$store.state.user.ShopID,
			books: [],
			pageIndex: 1,
			pageRows: 15,
			count: 0,
			search: '',
			booksCode: '',
			moveBook: {},
			BooksNumCode: ''
		}
	},
	created() {
		this.getData = function() {
			this.$request.request({
				url: 'Books/getBooksByShopID',
				data: {
					pageCount: this.pageRows,
					ShopID: this.ShopID,
					pageIndex: this.pageIndex,
					searchText: this.search
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.count = res.count;
					this.books = res.books;
				}
			});

		}
		this.moveBook = () => {
			this.$request.request({
				url: 'Books/moveBooks',
				data: {
					OperatorID: this.$store.state.user.UserID,
					BooksNumCode: this.BooksNumCode,
					ShopID: this.ShopID
				},
				method: 'post'
			}).then(res => {
				this.$refs.booksCode.focus();
				this.BooksNumCode = '';
				this.$uil.showMessage({
					text: res.message,
					time: 500
				})
				if (res.result)
					this.getData();
			});
		}
	},
	filters: {
		bookState(v) {
			if (v == 0) return '正常';
			if (v == 1) return '下架';
			if (v == 2) return '借出';
		}
	},
	methods: {
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			this.books = [];

			if (this.Shop.length > 0) {
				this.ShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		getBooks() {
			this.pageIndex = 1;
			this.getData();
			this.$refs.booksCode.focus();
		},
		changePages(s) {

			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}


	},
	computed: {
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}

	},
	activated() {
		this.getData();
	}


















}
